export enum FinishType {
  AFTER_LEAD_PARTNER_WEBSITE = 'after_lead_partner_website',
  CLAIM_PREQUAL_OFFER = 'claim_prequal_offer',
  EXTERNAL_APPLICATION = 'external_application',
  EXTERNAL_CONTENT = 'external_content',
  INTERNAL_CONTENT = 'internal_content',
  LEAD_INPUTFLOW = 'lead_inputflow',
}

export const ALL_FINISH_TYPES = Object.values(FinishType);

export const normalizeFinishType = (
  finishType: string
): FinishType | undefined => {
  const lowerCaseFinishType = finishType.toLowerCase();
  if (lowerCaseFinishType === 'external_application_referral') {
    return FinishType.EXTERNAL_APPLICATION;
  }
  if (lowerCaseFinishType === 'external_other_referral') {
    return FinishType.EXTERNAL_CONTENT;
  }
  if (lowerCaseFinishType === 'internal_referral') {
    return FinishType.INTERNAL_CONTENT;
  }
  return ALL_FINISH_TYPES.find((type) => type === finishType);
};
